import { Loading } from "@/components/src/animations/loading";
import { Search } from "lucide-react";
import { Input } from "@mui/material";
import {
	JobEntityType,
	SupabaseRpcEnum,
} from "../../../../lib/supabase/supabaseTypes";
import { showNotification } from "../../store/Central/selectors";
import { Logger } from "@/lib/logger/Logger";
import { supabase } from "@/lib/supabase/supabaseClient";
import React, { useState, useEffect } from "react";
import { useCentralStore } from "../../store/Central";
import { JobItemComponent } from "../../pages/Jobs/job-item.component";

export const JobSelectionComponent = ({
	handleSelect,
	setLoading,
	loading,
}: {
	handleSelect: (job: JobEntityType) => void;
	setLoading: (loading: boolean) => void;
	loading: boolean;
}) => {
	const { profile } = useCentralStore.getState();
	const [jobs, setJobs] = useState<JobEntityType[]>([]);
	const [allJobs, setAllJobs] = useState<JobEntityType[]>([]);

	const searchJobs = async (query: string) => {
		const normalizedQuery = query.trim();

		if (normalizedQuery.length < 2) {
			setJobs(allJobs);
			setLoading(false);
			return;
		}

		setLoading(true);

		// Filter jobs locally based on title or code
		const filteredJobs = allJobs.filter((job) => {
			const title = job.title?.toLowerCase() || "";
			const code = job.code?.toLowerCase() || "";
			const searchTerm = normalizedQuery.toLowerCase();

			return title.includes(searchTerm) || code.includes(searchTerm);
		});

		setJobs(filteredJobs);
		setLoading(false);
	};

	const getJobs = async () => {
		setLoading(true);

		const { data, error } = await supabase.rpc(
			SupabaseRpcEnum.GET_PENDING_JOBS,
			{
				org_id: profile?.organization_id as string,
			}
		);

		if (error) {
			Logger.error(error, {}, "Error fetching jobs");
			showNotification({
				message: "Fehler beim Abrufen von Jobs",
				type: "error",
			});
			return;
		}

		setJobs(data);
		setAllJobs(data);
		setLoading(false);
	};

	useEffect(() => {
		getJobs();
	}, []);

	return (
		<div className="h-full flex flex-col overflow-hidden pb-10">
			<div className="flex-none">
				<div className="flex items-center">
					<Input
						placeholder="Suche"
						endAdornment={<Search size={20} className="mr-2" />}
						onChange={(e) => {
							searchJobs(e.target.value);
						}}
						fullWidth
					/>
				</div>
			</div>
			<div className="flex-1 overflow-y-auto mt-4">
				<div className="flex flex-col gap-2 pb-2">
					{loading ? (
						<div className="mt-8">
							<Loading />
						</div>
					) : (
						<>
							{jobs?.length > 0 ? (
								jobs.map((job) => (
									<JobItemComponent
										key={job.id}
										jobTitle={job.title ?? ""}
										jobCode={job.code ?? ""}
										onSelect={() => handleSelect(job)}
									/>
								))
							) : (
								<div className="text-center py-4">
									Keine Jobs mit ausstehenden Dokumenten
									gefunden
								</div>
							)}
						</>
					)}
				</div>
			</div>
		</div>
	);
};
